webpackJsonp([70],{

/***/ "MVO1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/icon-text-list_0c852ae1f083070b7e9af084430c35f2.html";

/***/ }),

/***/ "ORkG":
/***/ (function(module, exports, __webpack_require__) {

var IconTextList = (function () {
    function IconTextList() {
    }
    return IconTextList;
}());
angular.module('animatronApp.iconTextList', []).component('iconTextList', {
    bindings: {
        list: '<',
    },
    controller: IconTextList,
    templateUrl: __webpack_require__("MVO1")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/70-28dc41a6a889e793a2e2.min.js